module.exports = __webpack_public_path__ + "static/media/font-awesome-logo-full.5258b45b.svg";